/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC } from "react";
import { T } from "@adapptio/lib-components";
import { TGenericModelNode } from "@adapptio/lib-blueprint";
import { PanelNote } from "../Panel";
import { termsEditorInspector } from "../../../terms/inspector";

export interface IInvalidModelNodeProps {
	model: TGenericModelNode;
}

export const InvalidModelNode: FC<IInvalidModelNodeProps> = ({ model }) => {
	return (
		<PanelNote>
			<p>
				<T domain="editor" term={termsEditorInspector.errors.internalInvalidModelNode} />
			</p>
			<p>{model ? `Model schema: ${model.schema.name}` : "Model is null."}</p>
		</PanelNote>
	);
};
